export default __webpack_public_path__ + "static/media/KickShort.63e85398.mp3";